interface LabelProps {
  name: string;
  optional?: boolean;
}

const Label = ({ name, optional }: LabelProps) => {
  return (
    <label className="required block text-sm font-medium text-gray-700">
      {name}{' '}
      {optional ? <span className="italic text-gray-500">(optional)</span> : ''}
    </label>
  );
};

export default Label;
